import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { useOccContext } from '../../../../context/occ/hooks/use-occ-context';
import { Image } from '../../../../subcomponents/image/image';
import { ImagePlaceholderType } from '../../../../subcomponents/image/types/placeholder-type';
import { getFilmCdnUrlForMedia } from '../../../../utils/get-film-cdn-url-for-media';
import { FilmImageMediaType } from '../types/media-type';
const b = bemClassBuilder('v-film-image');
export const FilmImageUI = observer(props => {
    const i18n = useI18n();
    const { accessibilityText } = useOccContext();
    const { config, cdnOptions, film } = props;
    const { mediaType } = config;
    const altTextFormat = getAltTextFormatForMediaType(accessibilityText, mediaType);
    return (_jsx("div", { className: b.block({ mediaType }), children: _jsx(Image, { className: b.element('img'), src: getFilmCdnUrlForMedia(film, mediaType, cdnOptions.filmImage), placeholderType: getImagePlaceholderType(mediaType), alt: getFormattedFilmImageAltText(i18n, altTextFormat, film) }) }));
});
FilmImageUI.displayName = 'FilmImageUI';
const getFormattedFilmImageAltText = (i18n, template, film) => {
    return i18n.template(template, { filmTitle: i18n.translatable(film.title) });
};
const getAltTextFormatForMediaType = (accessibilityText, mediaType) => {
    switch (mediaType) {
        case FilmImageMediaType.Advertisement:
            return accessibilityText.filmAdvertisementAltTextFormat;
        case FilmImageMediaType.Backdrop:
            return accessibilityText.filmBackdropAltTextFormat;
        case FilmImageMediaType.Poster:
            return accessibilityText.filmPosterAltTextFormat;
        case FilmImageMediaType.Still:
            return accessibilityText.filmStillAltTextFormat;
        case FilmImageMediaType.TitleTreatment:
            return accessibilityText.filmTitleTreatmentAltTextFormat;
        default:
            throw new Error(`Cannot get alt text format for unknown FilmImageMediaType: '${mediaType}'.`);
    }
};
const getImagePlaceholderType = (mediaType) => {
    switch (mediaType) {
        case FilmImageMediaType.Advertisement:
            return ImagePlaceholderType.FilmAdvertisement;
        case FilmImageMediaType.Backdrop:
            return ImagePlaceholderType.FilmBackdrop;
        case FilmImageMediaType.Poster:
            return ImagePlaceholderType.FilmPoster;
        case FilmImageMediaType.Still:
            return ImagePlaceholderType.FilmStill;
        case FilmImageMediaType.TitleTreatment:
            return ImagePlaceholderType.FilmTitleTreatment;
        default:
            throw new Error(`Cannot ImagePlaceholderType for unknown FilmImageMediaType: '${mediaType}'.`);
    }
};
//# sourceMappingURL=ui.js.map